module.exports = __webpack_public_path__ + "img/1491407643.56d4b8fd.jpg";